export default __webpack_public_path__ + "static/media/pezeski-ghanooni.434bf3f5.png";